import { Injectable } from '@angular/core';

// Services
import { NavigationParam, RouteParam, ServiceBase } from '../service-base';

// Modèles
import { ConversationItem } from 'src/app/@shared/models/messaging/conversation-item.model';
import { Observable } from 'rxjs';

const CLASS_NAME = 'ConversationItem';
const ENDPOINT = `/conversation-items/`;

const ROUTES: RouteParam[] = [
    { key: 'markAsRead', path: '{id}/mark-as-read/' },
    { key: 'send', path: '{id}/send/' },
]

const NAVIGATIONS: NavigationParam[] = [
    { key: 'attachments', childClass: 'File', path: 'attachments/', resultCardinality: 'many' }
]


@Injectable({
    providedIn: 'root'
})
export class ConversationItemService extends ServiceBase {
    constructor() {
        super(CLASS_NAME, ENDPOINT);
        this.addRoutes(ROUTES);
        this.addNavigations(NAVIGATIONS);
    }

    public markAsRead(item: ConversationItem): void {
        let url = this.routes.markAsRead.replace('{id}', item.id.toString());
        this.update(item, {
            url: url,
            showMessages: false,
        });
    }

    public send$(item: ConversationItem): Observable<ConversationItem> {
        let url = this.routes.send.replace('{id}', item.id.toString());
        return this.update$(item, {
            url: url,
            showMessages: false,
        });
    }
}
